import { useNavigate } from "react-router-dom";
import { MRT_RowData } from "material-react-table";
import { GeneralTable } from "@/shared/components/ui";
import { useFetchProspecto } from "@/shared/actions/erp";
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { Grid } from "@mui/material";
import { IDataProspecto } from "@/shared/interfaces/erp/prospecto";
import { useTableColumnsProspecto } from "@/shared/hooks/useTableColumnsProspecto";
import { PermissionsEnum } from "@/auth/interfaces";
import CustomSearchFilterSupervisorVenta from "../componente/CustomSearchProspecto/CustomSearchFilterSupervisorVenta";
import { EstadoProspectoEnum } from "@/shared";

export default function ProspectoRealizadoPage() {

  useCheckPermissions(PermissionsEnum.api_view_prospecto);

  const navigate = useNavigate();
  const { columnsBase } = useTableColumnsProspecto({ estado_prospecto: EstadoProspectoEnum.FINALIZADO });

  const {
    globalFilter,
    pagination,
    dateBefore,
    dateAfter,
    onChangeFilter,
    setPagination,
    onChangeRangeDate,
    cleanFilter,

    vendedor,
    setVendedor
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const { isLoading, data: prospectoRes,
    isRefetching, } = useFetchProspecto({
      page: pageIndex + 1,
      estado_prospecto: EstadoProspectoEnum.FINALIZADO,
      fecha_solicitud_before: dateBefore, fecha_solicitud_after: dateAfter,
      page_size: pageSize,
      user_create: vendedor,
      ...filterObject,
      filterByState: false,

    });

  const onEdit = (e: MRT_RowData) => {
    var preventa = e as IDataProspecto;
    navigate('/ventas/preventa/crear/' + preventa.id_prospecto);
  }



  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CustomSearchFilterSupervisorVenta
          onChange={onChangeFilter}
          value={globalFilter}
          text="por Identificación"

          onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}
          setVendedor={setVendedor}
          //vendedor={vendedor}
        />
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<IDataProspecto>
          columns={columnsBase}
          data={prospectoRes?.data.data || []}

          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={prospectoRes?.data?.count}

          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          enableColumnActions={true}

          // // actions
          actionsColumnSize={120}
          // crud
          onEdit={onEdit}
          canDelete={false}
          positionActionsColumn='first'

          //ocultar accionespp
          enableEditing={false}

        />
      </Grid>
    </Grid>
  );



}